import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// reactstrap components
import { Card, CardBody } from "reactstrap";

import { Container, Group } from "@mantine/core";

import AuthService from "../../../../services/auth-api";
import { LightThemedButton, ThemedButton } from "@/components/ThemedButton";
import { TitleContainer } from "@/components/HeaderContainer";
import useLoginSession from "@/hooks/useLoginSession";

function ProfileDeleteAccount() {
	const { isLoginBySession, postErrorMessage } = useLoginSession();
	const { user: userData } = useSelector((state) => state.auth);
	let navigate = useNavigate();
	const [loading, setLoading] = useState(false);

	const handleSendOTP = () => {
		setLoading(true);
		AuthService.deleteAccountSendOtp()
			.then(
				() => {
					navigate("/profile/delete-account/otp-validation");
				},
				() => {},
			)
			.catch(() => {
				setLoading(false);
			});
	};

	return (
		<>
			<Container>
				<TitleContainer py={0}>{"Account Deletion"}</TitleContainer>
				<Card className='border-0 mt-4 mx-auto' style={{ maxWidth: "600px" }}>
					<CardBody className='px-lg-5 py-lg-5 text-center'>
						<div className=''>
							<p>
								{"Please confirm if you would like to proceed with the account deletion request."}
							</p>
						</div>
						<Group justify='center' mt={20}>
							<LightThemedButton
								onClick={() => {
									if (isLoginBySession) {
										postErrorMessage("Cancelled By User");
									} else {
										navigate(-1);
									}
								}}>
								Cancel
							</LightThemedButton>
							<ThemedButton onClick={handleSendOTP} disabled={loading} color='red'>
								{loading && <span className='spinner-border spinner-border-sm'></span>}
								{"Delete Account"}
							</ThemedButton>
						</Group>
					</CardBody>
				</Card>
			</Container>
		</>
	);
}

export default ProfileDeleteAccount;
